import { useRef, useState } from "react";
import { Loader2, Mic, Square } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const VoiceButton = ({ onText, testid = "voice-note-btn" }) => {
  const [state, setState] = useState("idle");
  const rec = useRef(null);
  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream);
      const chunks = [];
      mr.ondataavailable = (e) => chunks.push(e.data);
      mr.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        setState("busy");
        const fd = new FormData();
        fd.append("file", new Blob(chunks, { type: mr.mimeType || "audio/webm" }), "note.webm");
        try { onText((await api.post("/ai/transcribe", fd, { timeout: 90000 })).data.text); } catch (e) { toast.error(errMsg(e)); }
        setState("idle");
      };
      mr.start();
      rec.current = mr;
      setState("rec");
      setTimeout(() => mr.state === "recording" && mr.stop(), 120000);
    } catch { toast.error("Couldn't use the microphone. Check your browser allows it."); }
  };
  const stop = () => rec.current?.stop();
  return (
    <button type="button" onClick={state === "rec" ? stop : start} disabled={state === "busy"} data-testid={testid}
      title={state === "rec" ? "Stop recording" : "Record a voice note"}
      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors ${state === "rec" ? "animate-pulse border-red-400 bg-red-500/20 text-red-300" : "hover:bg-white/5"}`}>
      {state === "busy" ? <Loader2 className="h-4 w-4 animate-spin" /> : state === "rec" ? <Square className="h-3.5 w-3.5" /> : <Mic className="h-4 w-4" />}
    </button>
  );
};
